module.exports = __webpack_public_path__ + "img/delegation-icon.0f8d3caa.svg";